import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['soundSelect', 'pushCheckbox'];

  connect() {
    this.toggle();
  }

  toggle() {
    const pushEnabled = this.pushCheckboxTarget.checked;
    this.soundSelectTarget.classList.toggle('d-none', !pushEnabled);
  }
}
